import React, {FC, useEffect, useState} from 'react';
import ordersService from "../../api/services/ordersService";

import {Button} from "../commons";
import {Upd} from "./UpdList";
import trashIcon from "assets/images/trashBin.svg";
import downIcon from "assets/images/moveLayerDown.svg";

interface UpdItemProps {
    item: Upd,
    updList: Upd[]
    setUpdList: (list: Upd[]) => void
}

const UpdItem: FC<UpdItemProps> = ({item, updList, setUpdList}) => {
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    function handleClickDelete(updId: number){
        setIsDeleting(true)
        setTimeout(() => {
            ordersService.deleteUpd(updId).then(
                (res) => {
                    if (res.data.success) {
                        const index = updList.findIndex((a: { id: number; }) => a.id === updId);
                        if (index === -1) return;
                        updList.splice(index, 1);
                        setUpdList([...updList])
                    }
                },
                (err) => {
                    alert('Failed delete upd: ' + err.message)
                }
            )
                .catch((err) => {
                    alert('Failed delete upd: ' + err.message)
                })
                .finally(() => {
                    setIsDeleting(false)
                })
        }, 500);
    }

    function handleClickDownload(xml:string){
        const href = URL.createObjectURL(
            new Blob([xml], {
                type: "application/xml"
            })
        )

        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.setAttribute('href', href);
        link.setAttribute('download', 'upd.xml');
        link.click();
        setTimeout(() => {
            document.body.removeChild(link)
        }, 500)
    }

    return (
         <tr className="flex flex-wrap md:table-row md:flex-no-wrap border-b border-gray-200 py-2 md:py-0">
             <td className="w-full block md:w-auto md:table-cell py-0.5 md:py-2">
                 <div className="text-left font-medium text-gray-800">{item.number}</div>
             </td>
             <td className="w-full block md:w-auto md:table-cell py-0.5 md:py-2">
                 <div className="text-left">{item.amount}</div>
             </td>
             <td className="w-full block md:w-auto md:table-cell py-0.5 md:py-2">
                 <div className="text-left font-medium">{item.date}</div>
             </td>
             <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                 <div className="flex items-center justify-end">
                     {item.xml ? <button className='text-gray-400 hover:text-gray-500 rounded-full mr-2' onClick={() => handleClickDownload(item.xml)}><span className="sr-only">Скачать</span><img src={downIcon} className="" /></button> : ''}
                     <Button
                         customClassName='text-gray-400 hover:text-gray-500 rounded-full'
                         loading={isDeleting}
                         clickHandler={() => handleClickDelete(item.id)}
                     >
                         <span className="sr-only">Удалить</span>
                         {!isDeleting && <img src={trashIcon} className="" /> }
                     </Button>
                 </div>

             </td>
         </tr>
  );
};

export default UpdItem;